import React from "react";
import { Label } from "./ui/label";
import { Input } from "./ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export const FRETE_OPCOES = [
  { v: "CIF", l: "CIF - Frete por conta da Locativo" },
  { v: "FOB", l: "FOB - Coleta e Entrega por conta do cliente" },
];

export const cidadeUf = (d) => {
  if (!d) return "";
  const uf = d.uf || d.estado;
  return d.cidade && uf ? `${d.cidade}/${uf}` : d.cidade || "";
};

export const FreteLocalFields = ({ frete, local, onFrete, onLocal, prefix = "proposta" }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
    <div>
      <Label>Frete *</Label>
      <Select value={frete || ""} onValueChange={onFrete}>
        <SelectTrigger data-testid={`${prefix}-frete`}><SelectValue placeholder="Selecione CIF ou FOB" /></SelectTrigger>
        <SelectContent>
          {FRETE_OPCOES.map((o) => (
            <SelectItem key={o.v} value={o.v} data-testid={`${prefix}-frete-${o.v}`}>{o.l}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
    <div>
      <Label>Local de operação</Label>
      <Input value={local || ""} onChange={(e) => onLocal(e.target.value)} placeholder="Cidade/UF onde o equipamento vai operar" data-testid={`${prefix}-local-operacao`} />
    </div>
  </div>
);
